// extracted by extract-css-chunks-webpack-plugin
module.exports = {"iconWithCursor":"Icon__iconWithCursor___1iwkJ","iconStack":"Icon__iconStack___2n5qj"};
    if(module.hot) {
      // 1778083490415
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  